import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";

const GET_LANGUAGE = gql`
    query getLanguage($filter: LanguageSearchInput, $limit: Int, $offset: Int, $orderBy: String) {
        getLanguage(filter: $filter, limit: $limit, offset: $offset, orderBy: $orderBy) {
            ... on LanguageArray {
                data {
                    _id
                    id
                    code
                    name
                    nativeName
                    countryCode
                    translationFile
                    version
                    isActive
                    createdBy {
                        username
                    }
                    updatedBy {
                        username
                    }
                }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getLanguage(code) {
    const variables = {
        filter: {
            isActive: true,
            code: code || localStorage?.getItem("language") || "en"
        },
    };

    return await ApolloClientQuery(GET_LANGUAGE, variables, false);
}

const GET_LANGUAGE_VERSION = gql`
    query getLanguageVersion($code: String!) {
        getLanguageVersion(code: $code) {
            ... on LanguageVersion {
                code
                version
                updatedAt
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getLanguageVersion() {
    const variables = {
        code: localStorage?.getItem("language") || "en"
    };

    return await ApolloClientQuery(GET_LANGUAGE_VERSION, variables, false);
}